import React, { Component } from "react";
import { Modal, Button, OverlayTrigger, Popover } from "react-bootstrap";
import TablePlain from "../../../components/table-plain/TablePlain";
import TableUtils from "../../../utils/TableUtils";
import lstrings from "../../../utils/LStrings";
import PropTypes from "prop-types";
import ApiClient from "../../../utils/ApiClient";

class NominaDialog extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    console.log("items", this.props.info);
    return (
      <Modal show={this.props.show}>
        <Modal.Header>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="largeModal">
          <TablePlain
            columns={[lstrings.cuil, lstrings.nombre, lstrings.rangoingreso]}
            columnsBold={true}
            rows={this.props.info.map((item, ix) => (
              <tr key={ix}>
                <td>{TableUtils.cuilFormat(item.cuil)}</td>
                <td>{item.nombre}</td>

                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={
                    <Popover id={`pop-${item.cuil}-${ix}`}>
                      <span>
                        {this.props.rangoIngresos[item.rangoIngresos]}
                      </span>
                    </Popover>
                  }
                >
                  <td style={{ cursor: "help" }}>
                    <span>{item.rangoIngresos}</span>
                  </td>
                </OverlayTrigger>
              </tr>
            ))}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.props.onCloseDialog}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

NominaDialog.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  info: PropTypes.any,
  onCloseDialog: PropTypes.func,
  rangoIngresos: PropTypes.object,
};

NominaDialog.defaultProps = {
  show: false,
  title: "",
};

export default NominaDialog;



// WEBPACK FOOTER //
// ./src/components/table-empleados-aportes/components/NominaDialog.js